import { ConfigAccountView } from './Account';

export default ConfigAccountView;